import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { APP_CONFIG } from '../../config/app-config';
import { ImpersonationService } from '../../services/impersonation.service';

export const impersonationInterceptorFn: HttpInterceptorFn = (request, next) => {
  const appConfig = inject(APP_CONFIG);

  const isRequestToNewApi = request.url.startsWith(appConfig.newApiUrl);
  if (!isRequestToNewApi) {
    return next(request);
  }

  const impersonationService = inject(ImpersonationService);
  const activeImpersonationDriverLoginEmail = impersonationService.activeImpersonationDriverLoginEmail();
  if (activeImpersonationDriverLoginEmail) {
    request = request.clone({
      headers: request.headers.append('X-Impersonation-Driver-Login-Email', activeImpersonationDriverLoginEmail)
    });
  }
  return next(request);
};
